import SpriteSymbol from "../../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "kd-icon-delete",
  "use": "kd-icon-delete-usage",
  "viewBox": "0 0 1066 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1066 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"kd-icon-delete\"><path d=\"M862.293333 469.333333a50.346667 50.346667 0 0 1 55.04 42.666667 48.213333 48.213333 0 0 1-48.64 42.666667H204.373333a50.346667 50.346667 0 0 1-55.04-42.666667 48.213333 48.213333 0 0 1 48.64-42.666667h664.32z\" p-id=\"2191\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol